import React from 'react';
import PropTypes from 'prop-types';

function SelectOptionPage({ data, selectedValue, setSelectedValue }) {
  return (
    <section className="section">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <ul className="select-list list-unstyled cursor-pointer">
              {data.map((item, index) => (
                <a
                  key={index}
                  role="button"
                  tabIndex={0}
                  onClick={() => setSelectedValue(item.optionValue)}
                >
                  <li
                    key={index} style={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'space-between',
                      alignItems: 'center'
                    }}
                  >
                    {item.optionTitle}
                    {item.optionValue === selectedValue ? (
                      <i
                        className="fas fa-check"
                      />
                    ) : null}
                  </li>
                </a>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}

SelectOptionPage.defaultProps = {
  selectedValue: '',
  setSelectedValue: () => {},
};

SelectOptionPage.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    optionTitle: PropTypes.string.isRequired,
    optionValue: PropTypes.number.isRequired,
  })).isRequired,
  selectedValue: PropTypes.number,
  setSelectedValue: PropTypes.func,
};

export default SelectOptionPage;
